<script setup lang="ts">
const { contractId, flowType } = defineProps<{
  contractId: string | number
  flowType: 'client' | 'owner'
}>()
const model = ref(true)

const { t } = useI18n()
const localePath = useLocalePath()
const { isMobile } = useBreakpoint()

const { contract } = await useReservationAgreement(
  contractId.toString(),
  flowType,
)

const redirectToContract = () => {
  const path = localePath({
    name: `reservationAgreement-id-${flowType === 'client' ? 'identityDocument' : 'reservationRequest'}`,
    params: {
      id: contractId,
    },
  })
  model.value = false
  if (path) return navigateTo(path)
}
</script>

<template>
  <BaseModalV2
    v-model="model"
    mobile-full-height
    :primary-button="isMobile ? '' : t(`${flowType}.cta`)"
    @primary-button="redirectToContract"
  >
    <template #content>
      <ReservationAgreementContinueOnMobile
        v-if="isMobile"
        :contract-id="contractId"
        :flow-type="flowType"
      />
      <div v-else class="mb-2 flex flex-col gap-6">
        <h2 class="text-4xl">
          {{ t(`${flowType}.title`) }}
        </h2>

        <ReservationAgreementClientInformationCard
          v-if="contract"
          :check-in-date="contract.checkInDate"
          :check-out-date="contract.checkOutDate"
          :destination="contract.destination"
          :house-name="contract.houseName"
          :house-photo="contract.houseFirstPhotoUrl"
          size="small"
        />

        <I18nT :keypath="`${flowType}.text`" tag="p">
          <template #bold>
            <strong>
              {{ t('owner.bold') }}
            </strong>
          </template>
        </I18nT>
      </div>
    </template>
  </BaseModalV2>
</template>

<i18n lang="yaml">
fr:
  owner:
    title: Demande de réservation
    text: Un client souhaite réserver votre propriété. {bold}
    bold: Cette demande expirera dans 24h.
    cta: Voir la demande
  client:
    title: Confirmer votre réservation
    text: Il ne vous reste plus qu'une étape.
    cta: Aller à la réservation
en:
  owner:
    title: Reservation request
    text: A guest wants to book your property. {bold}
    bold: This request expires in 24h.
    cta: View reservation request
  client:
    title: Confirm your booking
    text: You only have one step left!
    cta: Go to reservation
</i18n>
